import React, { Component } from 'react'
import mlocale from 'antd/lib/date-picker/locale/zh_CN'
import moment from 'moment'
import {
    Row,
    Col,
    Button,
    Table,
    Input,
    Select,
    Popconfirm,
    Spin,
    Tooltip,
    Cascader,
    Form,
    Modal,
    DatePicker,
    Upload
} from 'antd'
import { app, api, config } from "../../app"
import utils from "../../utils"
import common from "../review/common"
import HonorWallLogs from "./HonorWallLogs"
import ReviewSearch from "../../components/ReviewSearch"

const Option = Select.Option
const FormItem = Form.Item

/**
 * 上传之前
 * @param file
 * @returns {boolean}
 */
function beforeUpload (file) {
    const isLt2M = file.size / 1024 / 1024 < 2
    if (!isLt2M) {
        app.alert('头像图片最大2MB!', 'warn')
    }
    return isLt2M
}

class HonorWall extends Component {
    constructor (props) {
        super(props)
        this.lastFetchId = 0
        this.state = {
            dataList: [],
            categoryList: [],
            filterCategoryList: [],
            loading: true,
            data_loading: false,
            search_loading: false,
            page: 1,
            total: 0,
            search_val: '',
            search_type: 'searchform_honorname',
            filter_search_val: '',
            sel_type: '0',
            typeList: [],
            teamList: [],
            edit_visible: false,
            edit_id: null,
            editInfo: {},
            searchList: [],
            provinceList: [],
            sel_level: [],
            type_loading: false,
            logs_visible: false,
            log_id: null
        }
    }

    async componentDidMount () {
        this._isMounted = true
        await this.typeSource()
        await this.categorySource()
        await this.dataSource(1)
        if (this.state.categoryList.findIndex(c => c.level === '3') !== -1) {
            await this.provinceSource()
        }
        if (this.state.categoryList.findIndex(c => c.level === '3' || c.level === '2') !== -1) {
            await this.teamSource()
        }
    }

    componentWillUnmount () {
        this._isMounted = false
    }

    /**
     * 类目类型数据
     */
    typeSource = async () => {
        await this.setData({ type_loading: true })
        let { flag, data, msg } = await app.post(api.HSelectTypeLists)
        if (flag === 1) {
            await this.setData({ typeList: data, type_loading: false })
        } else {
            app.alert(msg, "error")
        }
    }

    /**
     * 类型数据
     */
    categorySource = async () => {
        await this.setData({ loading: true })
        let { flag, data, msg } = await app.post(api.HSelectCategoryLists, { indexno: app.getData('indexno') })
        if (flag === 1) {
            let categoryList = [], filterCategoryList = []
            for (let i = 0; i < data.length; i++) {
                if (data[i].status) {
                    data[i].id = data[i].level
                    categoryList.push(data[i])
                    if (data[i].child && data[i].child.length > 1) {
                        let c = Object.assign({}, data[i])
                        c.child = [{
                            id: '0',
                            name: '全部'
                        }]
                        for (let j = 0; j < data[i].child.length; j++) {
                            c.child.push(data[i].child[j])
                        }
                        filterCategoryList.push(c)
                    } else {
                        filterCategoryList.push(data[i])
                    }
                }
            }
            await this.setData({
                categoryList,
                filterCategoryList,
                sel_level: [data[0].id, '0'],
                loading: false
            })
            console.log(categoryList, filterCategoryList)
        } else {
            app.alert(msg, "error")
        }
    }

    /**
     * 类目列表数据
     */
    // typeSource = async (level, type) => {
    //     await this.setData({ type_loading: true })
    //     let { flag, data, msg } = await app.post(api.HSelectTypeLists, { level })
    //     if (flag === 1) {
    //         data.forEach((item, i) => {
    //             item.id = `1-${i}`
    //             if (!item.child || !item.child.length) {
    //                 // delete item.child
    //                 item.child = [{ id: '2-1', name: '暂 无', disabled: true }]
    //             }
    //         })
    //         if (type === 'edit') {
    //             await this.setData({ edit_typeList: data, type_loading: false })
    //         } else {
    //             data.unshift({ id: '0', name: '全部' })
    //             await this.setData({ typeList: data, type_loading: false })
    //         }
    //     } else {
    //         app.alert(msg, "error")
    //     }
    // }

    /**
     * 省份列表数据
     */
    provinceSource = async () => {
        let { flag, data, msg } = await app.post(api.ProvinceCityList, {
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        })
        if (flag === 1) {
            await this.setData({ provinceList: data.map(d => ({ value: d.area_name, name: d.area_name })) })
        } else {
            app.alert(msg, "error")
        }
    }

    /**
     * 队伍列表数据
     */
    teamSource = async () => {
        let { flag, data, msg } = await app.post(api.ReportsTeamAll, {
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        })
        if (flag === 1) {
            await this.setData({ teamList: data.map(d => ({ value: d.teamno, name: d.teamname })) })
        } else {
            app.alert(msg, "error")
        }
    }

    /**
     * 列表数据
     */
    dataSource = async (page = 1) => {
        await this.setData({ page, dataList: [], data_loading: true })
        let { sel_level, sel_type, filter_search_val, search_type } = this.state
        let { flag, data, msg, count } = await app.post(api.HAdminLists, {
            page,
            search_val: filter_search_val,
            level: sel_level[0],
            category_id: sel_level[1],
            search_type: search_type,
            indexno: app.getData('indexno'),
            account: app.getData('account'),
            type_id: sel_type
        })
        if (flag !== 1) {
            app.alert(msg, "error")
            data = []
        }
        if (page === this.state.page) {
            await this.setData({
                total: parseInt(count || 0),
                dataList: utils.addArrayKey(data),
                data_loading: false
            })
        }
    }

    setData = (data) => app.setStateSync(this, data)

    /**
     * 打开编辑框
     */
    handleOpenEditModal = async (info) => {
        const state = { edit_visible: true }
        if (info) {
            let { sel_level } = this.state
            info.category_id = [sel_level[0], info.category_id]
            console.log(info.category_id)
            state.edit_id = info.id
            state.editInfo = info
            state.searchList = [{ name: info.fkey_name, value: info.fkey }]
        }
        this.setData(state)
    }

    /**
     * 删除
     */
    handleDel = async (id) => {
        app.alert('正在删除', 'loading')
        let { flag, msg } = await app.post(api.HAdminDelete, {
            id,
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        })
        app.alertDestroy()
        if (flag === 1) {
            app.alert('删除成功', "success")
            const { dataList, page } = this.state
            if (dataList.length > 1) {
                await this.dataSource(page)
            } else {
                await this.dataSource(page > 1 ? (page - 1) : 1)
            }
        } else {
            app.alert(msg, "error")
        }
    }

    /**
     * 关闭编辑框
     * @returns {Promise<void>}
     */
    handleCloseEditModal = async () => {
        await this.setData({ edit_visible: false, edit_id: null, editInfo: {} })
        this.props.form.resetFields()
    }

    /**
     * 表单类目变更
     * @param e
     * @returns {Promise<void>}
     */
    handleFormCategoryChange = async (value) => {
        this.props.form.setFieldsValue({ type_id: undefined, fkey: undefined })
        await this.setData({ searchList: [] })
    }

    /**
     * 提交编辑
     * @param e
     */
    handleEdit = (e) => {
        e.preventDefault()
        this.props.form.validateFieldsAndScroll(async (err, values) => {
            if (!err) {
                if (this.state.submit_loading) return
                await this.setData({ submit_loading: true })
                let { edit_id } = this.state
                let urls = []
                for (let i = 0; i < values.img.length; i++) {
                    let response = values.img[i].response
                    if (response && response.flag === 1) {
                        urls.push(response.data.url)
                    }
                }
                if (!urls.length) {
                    app.alert('荣誉图片上传未完成或失败', 'warn')
                    await this.setData({ submit_loading: false })
                    return
                }
                values.img = urls[0]
                values.indexno = app.getData('indexno')
                values.account = app.getData('account')
                values.category_id = values.category_id[values.category_id.length - 1]
                values.date = values.date.format('YYYY-MM-DD')
                let res = { msg: '发生错误' }, s_msg = ''
                if (edit_id) {
                    values.id = edit_id
                    res = await app.post(api.HAdminEdit, values)
                    s_msg = '编辑成功'
                } else {
                    res = await app.post(api.HAdminAdd, values)
                    s_msg = '添加成功'
                }
                const state = { submit_loading: false }
                if (res.flag === 1) {
                    app.alert(s_msg, 'success')
                    await this.setData(state)
                    await this.handleCloseEditModal()
                    await this.dataSource(1)
                } else {
                    app.alert(res.msg, 'error')
                    await this.setData(state)
                }
            }
        })
    }

    /**
     * 表单搜索
     * @param value
     * @returns {Promise<void>}
     */
    handleFormSearch = async (value) => {
        if (!value) {
            await this.setData({ searchList: [] })
            return
        }
        this.lastFetchId += 1
        const fetchId = this.lastFetchId
        await this.setData({ search_loading: true, searchList: [] })
        const state = { search_loading: false }, level = this.props.form.getFieldValue('category_id')
        switch (level[0]) {
            case '1':
                state.searchList = await this.handleSearchPlayer(value)
                break
            case '2':
                state.searchList = this.state.teamList.filter(p => p.name.indexOf(value) !== -1)
                break
            case '3':
                state.searchList = this.state.provinceList.filter(p => p.name.indexOf(value) !== -1)
                break
        }
        if (fetchId === this.lastFetchId) {
            await this.setData(state)
        }
    }

    /**
     * 搜索用户
     * @param val
     * @returns {Promise<*>}
     */
    handleSearchPlayer = async (val) => {
        let params = {
            search_val: val,
            search_type: 'searchform_name',
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        }, { flag, data, msg } = await app.post(api.NewsSearchPlayer, params)
        if (flag === 1) {
            return data.map(d => ({ value: d.indexno, name: `${d.vname} （${d.bsrno || ' - '}）` }))
        } else {
            app.alert(msg, "error")
            return []
        }
    }

    /**
     * 搜索队伍
     * @param val
     * @returns {Promise<*>}
     */
    handleSearchTeam = async (val) => {
        let params = {
            search_val: val,
            search_type: 'searchform_team',
        }, { flag, data, msg } = await app.post(api.HomeSearch, params)
        if (flag === 1) {
            return data.map(d => ({ value: d.teamno, name: d.teamname }))
        } else {
            app.alert(msg, "error")
            return []
        }
    }
    /**
     * 荣誉等级变更
     * @param value
     * @returns {Promise<void>}
     */
    handleCategoryChange = async (value) => {
        await this.setData({ sel_level: value })
        if (this.rs_ref) {
            this.rs_ref.handleSelectChange('searchform_honorname')
        }
        await this.dataSource(1)
    }

    /**
     * 打开修改记录弹框
     */
    handleOpenLogModal = (log_id) => {
        this.setData({ logs_visible: true, log_id })
    }

    /**
     * 关闭修改记录弹框
     */
    handleCloseLogModal = () => {
        this.setData({ logs_visible: false })
    }

    /**
     * 搜索
     * @param search_type
     * @param search_val
     */
    handleSearch = async (search_type, search_val) => {
        console.log(search_type, search_val)
        await this.setData({ search_type, filter_search_val: search_val })
        await this.dataSource(1)
    }

    render () {
        let {
                data_loading, dataList, categoryList, sel_level, loading, page, total, edit_id, edit_visible, editInfo, submit_loading,
                searchList, search_loading, typeList, logs_visible, log_id, filterCategoryList
            } = this.state,
            { getFieldDecorator, getFieldValue } = this.props.form,
            formItemLayout = {
                labelCol: { span: 6 },
                wrapperCol: { span: 10, offset: 1 },
            },
            columns = [
                {
                    title: '姓名',
                    dataIndex: 'fkey_name',
                    key: 'fkey_name',
                    width: '8%'
                },
                {
                    title: '存心编号',
                    dataIndex: 'bsrno',
                    key: 'bsrno',
                    width: '8%'
                },
                {
                    title: '所属队伍',
                    dataIndex: 'team',
                    key: 'team',
                    width: '9%',
                    render: (team) => team ? team.map(t => t.teamname).join('、') : ' - '
                },
                {
                    title: '荣誉名称',
                    dataIndex: 'name',
                    key: 'name',
                    width: '9%',
                    render: (t) => {
                        return <span style={{wordBreak: "break-word"}}>{t}</span>
                    }
                },
                {
                    title: '荣誉图片',
                    dataIndex: 'img',
                    key: 'img',
                    width: '10%',
                    render: (img) => {
                        return (
                            <a href={config.imgUrl + img} target="_blank">
                                <div className="hwmt-img">
                                    <img src={config.imgUrl + img} alt="图片"/>
                                </div>
                            </a>
                        )
                    }
                },
                {
                    title: '荣誉类型',
                    dataIndex: 'type_name',
                    key: 'type_name',
                    width: '9%',
                },
                {
                    title: '荣誉等级',
                    dataIndex: 'category_name',
                    key: 'category_name',
                    width: '9%',
                },
                {
                    title: '获奖日期',
                    dataIndex: 'date',
                    key: 'date',
                    width: '11%',
                },
                {
                    title: '审核状态',
                    dataIndex: 'is_audit',
                    key: 'is_audit',
                    width: '12%',
                    render: (audit, { audit_at, audit_by_name, audit_message }) => common.tableStatus(audit, audit_by_name, audit_at, audit_message)
                },
                {
                    title: '备注',
                    dataIndex: 'remark',
                    key: 'remark',
                    width: '6%',
                    render: (remark) => {
                        return remark ? (
                            <Tooltip title={remark}><span
                                style={{ color: '#1890ff', cursor: 'pointer' }}>查看</span></Tooltip>
                        ) : ' - '
                    }
                },
                {
                    title: '操作',
                    dataIndex: 'id',
                    key: 'id',
                    width: '9%',
                    render: (id, record) => {
                        return (
                            <div style={{ textAlign: 'center' }}>
                                <div>
                                    <Button type="primary" size="small"
                                            onClick={() => this.handleOpenEditModal(record)}>修改</Button>
                                </div>
                                <div>
                                    <Popconfirm
                                        title="确认删除吗？"
                                        onConfirm={() => this.handleDel(id)}
                                    >
                                        <Button type="danger" size="small" style={{ margin: '10px 0' }}>删除</Button>
                                    </Popconfirm>
                                </div>
                                <div>
                                    <Button size="small"
                                            onClick={() => this.handleOpenLogModal(id)}>修改记录</Button>
                                </div>
                            </div>
                        )
                    }
                },

            ],
            columns2 = [
                {
                    title: '名称',
                    dataIndex: 'fkey_name',
                    key: 'fkey_name',
                    width: '10%'
                },
                {
                    title: '荣誉名称',
                    dataIndex: 'name',
                    key: 'name',
                    width: '10%',
                    render: (t) => {
                        return <span style={{wordBreak: "break-word"}}>{t}</span>
                    },
                },
                {
                    title: '荣誉图片',
                    dataIndex: 'img',
                    key: 'img',
                    width: '10%',
                    render: (img) => {
                        return (
                            <a href={config.imgUrl + img} target="_blank">
                                <div className="hwmt-img">
                                    <img src={config.imgUrl + img} alt="图片"/>
                                </div>
                            </a>
                        )
                    }
                },
                {
                    title: '荣誉类型',
                    dataIndex: 'type_name',
                    key: 'type_name',
                    width: '10%',
                },
                {
                    title: '荣誉等级',
                    dataIndex: 'category_name',
                    key: 'category_name',
                    width: '10%',
                },
                {
                    title: '获奖日期',
                    dataIndex: 'date',
                    key: 'date',
                    width: '15%',
                },
                {
                    title: '审核状态',
                    dataIndex: 'is_audit',
                    key: 'is_audit',
                    width: '15%',
                    render: (audit, { audit_at, audit_by_name, audit_message, category_level }) => {
                        if (category_level === '3') {
                            return '无需审核'
                        }
                        return common.tableStatus(audit, audit_by_name, audit_at, audit_message)
                    }
                },
                {
                    title: '备注',
                    dataIndex: 'remark',
                    key: 'remark',
                    width: '10%',
                    render: (remark) => {
                        return remark ? (
                            <Tooltip title={remark}><span
                                style={{ color: '#1890ff', cursor: 'pointer' }}>查看</span></Tooltip>
                        ) : ' - '
                    }
                },
                {
                    title: '操作',
                    dataIndex: 'id',
                    key: 'id',
                    width: '10%',
                    render: (id, record) => {
                        return (
                            <div style={{ textAlign: 'center' }}>
                                <div>
                                    <Button type="primary" size="small"
                                            onClick={() => this.handleOpenEditModal(record)}>修改</Button>
                                </div>
                                <div>
                                    <Popconfirm
                                        title="确认删除吗？"
                                        onConfirm={() => this.handleDel(id)}
                                    >
                                        <Button type="danger" size="small" style={{ margin: '10px 0' }}>删除</Button>
                                    </Popconfirm>
                                </div>
                                <div>
                                    <Button size="small"
                                            onClick={() => this.handleOpenLogModal(id)}>修改记录</Button>
                                </div>
                            </div>
                        )
                    }
                },

            ],
            form_category_id = getFieldValue('category_id'),
            up_img = getFieldValue('img'),
            up_disabled = ((edit_id && editInfo.img) || (up_img && up_img.length >= 1)) ? true : false,
            form_search_msg = (categoryList.filter(c => c.level === (form_category_id || [-1])[0])[0] || { search_msg: '请输入关键词搜索' }).search_msg
        return (
            <div className="honor-wall ranks_content">
                <Row type="flex" justify="space-between" className="r_page_title">
                    <div>荣誉墙管理</div>
                    <Button icon="rollback" onClick={() => app.backPage(this)}>返回</Button>
                </Row>
                {
                    loading ? (<div style={{ textAlign: 'center', padding: '20px 0' }}><Spin size="large"/></div>) : (
                        <div className="hw-content">
                            <Row className="hw-btns" type="flex" justify="space-between" align="middle">
                                <Col>
                                    <span>荣誉等级：</span>
                                    <Cascader fieldNames={{ label: 'name', value: 'id', children: 'child' }}
                                              defaultValue={sel_level} options={filterCategoryList}
                                              displayRender={label => label.join(' -> ')} expandTrigger="hover"
                                              style={{ width: '14rem' }} allowClear={false}
                                              onChange={this.handleCategoryChange} placeholder="选择荣誉级别"/>
                                    <span style={{ margin: '0 1rem' }}>荣誉类型：</span>
                                    <Select style={{ marginRight: '1rem', width: '10rem' }} placeholder="选择荣誉类型"
                                            defaultValue="0" onChange={async value => {
                                        await this.setData({ sel_type: value })
                                        await this.dataSource(1)
                                    }}>
                                        <Option value="0">全部</Option>
                                        {
                                            typeList.map((m, i) => {
                                                return (
                                                    <Option key={i} value={m.id}>{m.name}</Option>
                                                )
                                            })
                                        }
                                    </Select>
                                    <ReviewSearch onSearch={this.handleSearch} defaultValue="searchform_honorname"
                                                  ref={(ref) => {
                                                      this.rs_ref = ref
                                                  }} notBorder
                                                  type={sel_level[0] === '1' ? 'honor-wall-user' : 'honor-wall-team_p'}/>
                                </Col>
                                <Col>
                                    <Button type="primary" onClick={() => this.handleOpenEditModal()}>分配荣誉</Button>
                                </Col>
                            </Row>
                            <Table columns={sel_level[0] === '1' ? columns : columns2}
                                   locale={app.tbLocale(data_loading)}
                                   loading={data_loading}
                                   dataSource={dataList}
                                   scroll={{ y: 'calc(100vh - 310px)' }}
                                   pagination={{
                                       current: page,
                                       pageSize: 20,
                                       total: total,
                                       showTotal: (t) => `总数量：${t}`,
                                       onChange: this.dataSource
                                   }}
                                   size="small"
                                   className="table-odd-even-row"
                            />
                        </div>
                    )
                }
                <Modal
                    visible={edit_visible}
                    footer={null}
                    title={edit_id ? '编辑荣誉' : '分配荣誉'}
                    maskClosable={false}
                    width='60%'
                    bodyStyle={{ height: '70vh', overflow: 'auto' }}
                    onCancel={() => this.handleCloseEditModal()}
                    destroyOnClose={true}
                >
                    <Form onSubmit={this.handleEdit}>
                        <FormItem
                            {...formItemLayout}
                            label="荣誉名称"
                        >{getFieldDecorator('name', {
                            initialValue: edit_id ? editInfo.name : null,
                            rules: [{ required: true, message: '请输入荣誉名称!' }],
                        })(
                            <Input placeholder="请填写"/>
                        )}
                        </FormItem>
                        <FormItem
                            {...formItemLayout}
                            label="荣誉等级"
                        >{getFieldDecorator('category_id', {
                            initialValue: edit_id ? editInfo.category_id : null,
                            rules: [{ required: true, message: '请选择荣誉类目!' }],
                        })(
                            <Cascader fieldNames={{ label: 'name', value: 'id', children: 'child' }}
                                      options={categoryList} placeholder="选择荣誉级别" expandTrigger="hover"
                                      onChange={this.handleFormCategoryChange} disabled={edit_id ? true : false}/>
                        )}
                        </FormItem>
                        {
                            edit_id || form_category_id ? (<FormItem
                                key="2"
                                {...formItemLayout}
                                label="分配对象"
                            >{getFieldDecorator('fkey', {
                                initialValue: edit_id ? editInfo.fkey : undefined,
                                rules: [{ required: true, message: '请选择分配对象!' }],
                            })(
                                <Select placeholder={form_search_msg} onSearch={this.handleFormSearch}
                                        notFoundContent={search_loading ? <Spin size="small"/> : "无搜索内容"}
                                        filterOption={false} disabled={edit_id ? true : false}
                                        defaultActiveFirstOption={false} showArrow={false} allowClear showSearch>
                                    {
                                        searchList.map((s) => {
                                            return (<Option key={s.value}>{s.name}</Option>)
                                        })
                                    }
                                </Select>
                            )}
                            </FormItem>) : null
                        }
                        <FormItem
                            {...formItemLayout}
                            key="1"
                            label="荣誉类型"
                        >{getFieldDecorator('type_id', {
                            initialValue: edit_id ? editInfo.type_id : undefined,
                            rules: [{ required: true, message: '请选择荣誉类型!' }],
                        })(
                            <Select placeholder="请选择荣誉类型" style={{ width: '100%' }}>
                                {
                                    typeList.map((m, i) => {
                                        return (
                                            <Option key={i} value={m.id}>{m.name}</Option>
                                        )
                                    })
                                }
                            </Select>
                        )}
                        </FormItem>
                        <FormItem
                            {...formItemLayout}
                            label="获奖日期"
                        >{getFieldDecorator('date', {
                            initialValue: edit_id ? moment(editInfo.date) : undefined,
                            rules: [{ required: true, message: '请选择获奖日期!' }],
                        })(
                            <DatePicker locale={mlocale} disabledDate={(current) => {
                                return current && current > moment().endOf('day')
                            }}/>
                        )}
                        </FormItem>
                        <FormItem
                            labelCol={{ span: 6 }}
                            wrapperCol={{ span: 17, offset: 1 }}
                            label="荣誉图片"
                        >
                            {getFieldDecorator("img", {
                                valuePropName: 'fileList',
                                getValueFromEvent: e => {
                                    if (Array.isArray(e)) {
                                        return e
                                    }
                                    return e && e.fileList
                                },
                                rules: [
                                    { required: true, message: '请上传荣誉图片!' },
                                    { type: 'array', max: 1, message: '最多上传一张图片!' },
                                ],
                                initialValue: edit_id && editInfo.img ? [{
                                    uid: '-1',
                                    status: 'done',
                                    response: {
                                        flag: 1,
                                        data: {
                                            url: editInfo.img
                                        }
                                    },
                                    name: "图片",
                                    thumbUrl: config.imgUrl + editInfo.img
                                }] : []
                            })(
                                <Upload
                                    accept='image/jpeg, image/jpg, image/png'
                                    action={config.serverUrl + api.ImageUpload}
                                    listType="picture"
                                    beforeUpload={beforeUpload}
                                    data={{
                                        token: app.getData('token'),
                                        indexno: app.getData('indexno'),
                                        account: app.getData('account'),
                                        upload_type: 'honor'
                                    }}
                                    name="image"
                                    disabled={up_disabled}
                                    className="upload-list-inline"
                                    onRemove={() => {
                                        if (edit_id) {
                                            editInfo.img = ''
                                        }
                                    }}
                                >
                                    <Button disabled={up_disabled}>上传图片</Button>
                                </Upload>
                            )}
                        </FormItem>
                        <FormItem
                            {...formItemLayout}
                            label="备注信息"
                        >{getFieldDecorator('remark', {
                            initialValue: edit_id ? editInfo.remark : null,
                        })(
                            <Input.TextArea rows={8}/>
                        )}
                        </FormItem>
                        <FormItem
                            wrapperCol={{ span: 10, offset: 7 }}
                        >
                            <Button type="primary" htmlType="submit" loading={submit_loading} block>提交</Button>
                        </FormItem>
                    </Form>
                </Modal>
                <Modal
                    visible={logs_visible}
                    maskClosable={false}
                    width='80%'
                    bodyStyle={{ height: 'calc(80vh - 56px)', padding: 10, overflow: 'auto' }}
                    onCancel={this.handleCloseLogModal}
                    footer={null}
                    destroyOnClose={true}
                    title="修改记录"
                    centered
                >
                    <HonorWallLogs id={log_id}/>
                </Modal>
            </div>
        )
    }
}

export default Form.create()(HonorWall)



// WEBPACK FOOTER //
// ./src/routes/ranks/HonorWall.jsx